import { styled } from '@mui/system';

interface Props {
  name: string;
  parentName?: string | null;
  showSeparator?: boolean;
}

const StyledSpan = styled('span')`
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-all;
  hyphens: auto;
`;

export function GovmapGroupsListItem({
  name,
  parentName,
  showSeparator,
}: Props) {
  return (
    <>
      <StyledSpan>
        {parentName ? (
          <>
            <strong>{parentName}</strong>
            {' - '}
            <span>{name}</span>
          </>
        ) : (
          <strong>{name}</strong>
        )}
      </StyledSpan>
      {showSeparator ? ', ' : ''}
    </>
  );
}
